<template>
  <!-- Where the page header already shows the timer, a running reservation has nothing to add here. -->
  <ReservationTimer v-if="cartStore.timeLeft && !hideTimer" />
  <template v-else-if="cartStore.timeLeft"></template>
  <Alert v-else-if="!cartStore.loading && !cartStore.items?.length" status="warning">
    {{ $t("There are no items in your shopping cart right now...") }}
  </Alert>
  <div v-else-if="!cartStore.loading" class="flex flex-col gap-2">
    <div class="grow text-foreground">{{ $t("Tickets are no longer reserved.") }}</div>
    <Button @click.prevent="updateReservation('reserve-again')">
      {{ $t("Reserve again for 10 minutes") }}
    </Button>
  </div>
</template>
<script setup>
import ReservationTimer from "./ReservationTimer.vue";
import { useCartStore } from "@/store/cart.ts";
import { Alert, Button } from "@xs2event/js-lib/components";

defineProps({
  hideTimer: { type: Boolean, default: false },
});

const cartStore = useCartStore();
const updateReservation = async (action) => {
  cartStore.reservationId = null;
  await cartStore.updateReservation(action);
};
</script>
